/**
 * 承認 đơn tài khoản con (アソシエイツ) — dùng chung cho MyPage list và trang
 * order detail. Port `ps_order::orderApprove` phía UI:
 *   - confirm popup 「ご注文を承認します。よろしいですか?」
 *     (account.order_details.tpl.php:443)
 *   - kết quả hiện bằng banner inline vành xanh/đỏ ở đầu vùng nội dung, KHÔNG
 *     modal (:165-176); câu chữ dùng order_id thô như Joomla (:168)
 *
 * Usage:
 *   const ok = await window.inkOrderApprove.run(orderId, bannerEl);
 *   if (ok) await reload();
 */
(() => {
  const CONFIRM_TEXT = 'ご注文を承認します。よろしいですか?';
  const FAIL_TEXT = '注文の承認に失敗しました。';

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /**
   * Chỉ nhận câu tiếng Nhật do API dựng. Body 5xx của Laravel là tiếng Anh
   * ("Server Error") và `_fetch` trả `{data:null,error}` khi lỗi mạng — cả hai
   * đều không phải text hiển thị được cho khách.
   */
  function messageOf(json, fallback) {
    const raw = json && typeof json.message === 'string' ? json.message : '';
    return /[　-ヿ一-鿿]/.test(raw) ? raw : fallback;
  }

  function showBanner(box, ok, text) {
    if (!box) return;
    const cls = ok
      ? 'mb-4 rounded border-2 border-ink-green bg-white p-3 font-bold text-ink-blue'
      : 'mb-4 rounded border-2 border-ink-red bg-white p-3 font-bold text-ink-red';
    box.className = cls;
    box.innerHTML = esc(text).replace(/\n/g, '<br>');
    box.hidden = false;
    box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  async function run(orderId, bannerEl) {
    if (!window.confirm(CONFIRM_TEXT)) return false;

    window.inkProcessing?.show();
    try {
      const json = await window.inkApi.post(`/orders/${orderId}/approve`, {});
      if (!json || !json.data) {
        showBanner(bannerEl, false, messageOf(json, FAIL_TEXT));
        return false;
      }
      showBanner(bannerEl, true, json.data.message || `${orderId}の注文を承認しました。`);
      return true;
    } catch (e) {
      console.warn('approve fail', e);
      showBanner(bannerEl, false, FAIL_TEXT);
      return false;
    } finally {
      window.inkProcessing?.hide();
    }
  }

  window.inkOrderApprove = { run, showBanner };
})();
